
const state = {
  itemReceipt: {
    show: false
  },
  requestRoom: {
    show: false
  },
  videoView: {
    show: false,
    tab1: {
      list: [],
      offset: 0,
      totcount: 0
    },
    tab2: {
      list: [],
      offset: 0,
      totcount: 0
    },
    tab: 1
  }
}

const getters = {
}

const mutations = {
}

const actions = {
  requestBoardData ({ commit, state }, p) {
    return this.requestData(`/rep.board.api`, { 'param': p }, {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/board.js